import React, { useState } from "react";

import { Plus, X } from "lucide-react";

import { Badge } from "./ui/badge";
import { Button } from "./ui/button";
import { Input } from "./ui/input";

const ListManager = ({ items, onAdd, onRemove, label, placeholder }) => {
  const [newItem, setNewItem] = useState("");

  return (
    <div className="space-y-2">
      <h4 className="font-medium">{label}</h4>

      <div className="flex gap-2">
        <Input
          placeholder={placeholder}
          value={newItem}
          onChange={(e) => setNewItem(e.target.value)}
          onKeyPress={(e) => {
            if (e.key === "Enter" && newItem.trim()) {
              onAdd(newItem.trim());
              setNewItem("");
            }
          }}
        />

        <Button
          variant="outline"
          onClick={() => {
            if (newItem.trim()) {
              onAdd(newItem.trim());
              setNewItem("");
            }
          }}
        >
          <Plus className="h-4 w-4" />
        </Button>
      </div>

      <div className="space-y-2">
        {items.map((item, index) => (
          <Badge key={index} className="text-sm ml-2">
            {item}
            <button
              className="ml-2 rounded-full outline-none ring-offset-background focus:ring-2 focus:ring-ring focus:ring-offset-2"
              onClick={() => onRemove(index)}
            >
              <X className="h-4 w-4 text-muted-foreground hover:text-foreground" />
            </button>
          </Badge>
        ))}
      </div>
    </div>
  );
};

export default ListManager;
